import * as React from "react";
import { styled } from "@mui/system";
import MUISnackbar from "@mui/material/Snackbar";
import { SnackbarProps as SnackbarPropsMUI } from "@mui/material/Snackbar";
export interface SnackbarProps extends SnackbarPropsMUI {}

export const Snackbar: (props: SnackbarProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, SnackbarProps>((props, ref) => (
    <MUISnackbar ref={ref} {...props} />
  )),
  {
    name: "Snackbar",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme, children }) => ({
  "&.MuiSnackbar-root.MuiSnackbar-anchorOriginTopRight ": {
    right: 32
  },
  "&.MuiSnackbar-root .MuiSnackbarContent-root": {
    background: children && "transparent",
    boxShadow: children && "none"
  }
}));
